const getReadableSize = (bytes: number) => {
  let i = -1;
  let size = bytes;
  const byteUnits = ['KB', 'MB', 'GB'];
  do {
    size /= 1000;
    i += 1;
  } while (size > 1000 && i <= byteUnits.length);

  return Math.max(size, 0.1).toFixed(1) + byteUnits[i];
};

export default getReadableSize;
